import Swal from 'sweetalert2';
import { ucFirst } from '../AppUtil/AppUtil';
import Session from '../Service/Session';

import i18n from '../i18n';

window.Swal = Swal;
i18n.loadNamespaces('Core');

export function toastWhenPaymentMethodBank(name, payment, accept, close, fromViewSummary) {
	const currentUser = Session.get('CURRENT_USER_INFO');
	const accounInfo = currentUser.profile.account !== null ? currentUser.profile.account : '';
	let acceptanceMessage = '';
	if (fromViewSummary) {
		acceptanceMessage = 'sweetalert.payment_method_bank';
	} else {
		acceptanceMessage = 'sweetalert.payment_method_bank_while_accept';
	}
	const message = i18n.t(acceptanceMessage, {
		borrower_name: name,
		bank_name: accounInfo.institution_name,
		bank_type: accounInfo.type,
		mask: accounInfo.account_mask
	});
	Swal.fire({
		text: message,
		icon: 'warning',
		showCancelButton: true,
		confirmButtonColor: '#3085d6',
		cancelButtonColor: '#d33',
		cancelButtonText: i18n.t('buttons.cancel'),
		customClass: 'otp_message_success',
		confirmButtonText: fromViewSummary ? i18n.t('buttons.send_loan_offer') : i18n.t('buttons.transfer_loan_funds')
	}).then(result => {
		if (result.value) {
			accept(payment);
			close();
		}
	});
}

export function toastWhenPaymentMethodCash(name, payment, accept, close) {
	const acceptanceMessage = i18n.t('sweetalert.payment_method_cash', {
		borrower_name: name
	});
	Swal.fire({
		animation: false,
		title: i18n.t('sweetalert_title.thank_you'),
		text: acceptanceMessage,
		icon: 'success',
		customClass: 'otp_message_success',
		confirmButtonText: i18n.t('buttons.ok')
	}).then(() => {
		accept(payment);
		close();
	});
}

export function toastWhenPaymentMethodCashPastDate(payment, accept, close) {
	// NOSONAR
	const acceptanceMessage = i18n.t('sweetalert.loan_accepted_lender_offline_past_date');
	Swal.fire({
		title: i18n.t('sweetalert_title.are_you_sure'),
		text: acceptanceMessage,
		icon: 'warning',
		showCancelButton: true,
		confirmButtonColor: '#3085d6',
		cancelButtonColor: '#d33',
		customClass: 'otp_message_success',
		cancelButtonText: i18n.t('buttons.cancel'),
		confirmButtonText: i18n.t('buttons.ok')
	}).then(res => {
		if (res.value) {
			accept(payment);
			close();
		}
	});
}

export function toastError(error) {
	Swal.fire({
		title: i18n.t('sweetalert_title.error'),
		text: error,
		// icon: 'error',
		imageUrl: 'https://cdn-icons-png.flaticon.com/512/5219/5219070.png',
		confirmButtonText: i18n.t('buttons.ok'),
		customClass: 'otp_message_success',
		imageAlt: 'Custom image'
	});
}

export function toastWhenLoanStopOrResume(action) {
	Swal.fire({
		text: i18n.t('sweetalert.text_for_stop_payment_popup'),
		html: `${i18n.t('sweetalert_title.are_you_sure')}<br><strong>${i18n
			.t('sweetalert.text_for_stop_payment_popup')
			.toUpperCase()}</strong>`,
		icon: 'warning',
		allowHtml: true,
		showCancelButton: true,
		reverseButtons: false,
		confirmButtonColor: '#27B88D',
		confirmButtonText: i18n.t('label.yes').toUpperCase(),
		cancelButtonColor: '#FFFFFF',
		cancelButtonText: i18n.t('label.no').toUpperCase(),
		customClass: 'otp_message_success'

		// customClass: {
		// 	confirmButton: 'circular-button',
		// 	cancelButton: 'circular-button'
		// }
	}).then(result => {
		if (result.value) {
			action();
		}
	});
}

export function popUpOnCancelTranfer(text, cancel, data) {
	Swal.fire({
		html: i18n.t('sweetalert.popup_text_for_cancel_transfer'),
		icon: 'warning',
		showCancelButton: true,
		reverseButtons: false,
		confirmButtonColor: '#27B88D',
		confirmButtonText: i18n.t(text),
		cancelButtonColor: '#FFFFFF',
		cancelButtonText: i18n.t('buttons.close'),
		customClass: 'otp_message_success'
		// customClass: {
		// 	confirmButton: 'circular-button',
		// 	cancelButton: 'circular-button'
		// }
	}).then(result => {
		if (result.value) {
			cancel(data);
		}
	});
}

export function toastOnResendLoan(typeOfLoan, nameofAcceptor, callback, onBack, data, loanState) {
	const acceptanceMessage = i18n.t('sweetalert.text_for_loan_resend_popup', {
		loan_type: typeOfLoan,
		loan_acceptor: nameofAcceptor
	});
	if (loanState === 'DRAFTED') {
		callback(data);
		onBack();
		return;
	}
	Swal.fire({
		// title: i18n.t("sweetalert_title.are_you_sure"),

		html: `${i18n.t('sweetalert_title.are_you_sure')}<br><strong>${acceptanceMessage.toUpperCase()}</strong>`,
		icon: 'warning',
		allowHtml: true,
		showCancelButton: true,
		reverseButtons: false,
		confirmButtonColor: '#27B88D',
		confirmButtonText: i18n.t('label.yes').toUpperCase(),
		cancelButtonColor: '#FFFFFF',
		cancelButtonText: i18n.t('label.no').toUpperCase(),
		customClass: 'otp_message_success'
		// customClass: {
		// 	confirmButton: 'circular-button',
		// 	cancelButton: 'circular-button'
		// }
	}).then(result => {
		if (result.value) {
			callback(data);
			onBack();
		}
	});
}

export function viewUserDetails(userDetails, callback, loanObject, showEditButton) {
	const email = userDetails.email ? userDetails.email : '';
	const phone = userDetails.phone ? userDetails.phone : '';
	const relationship = i18n.t(`label.${loanObject.relationship.toLowerCase()}`);
	Swal.fire({
		html:
			`<table class="popup"><tr><td>${i18n.t('label.full_name')}:</td><td style="word-break: break-word">${
				userDetails.name
			}</td></tr>` +
			`<tr><td>${i18n.t('label.relationship')}:</td><td style="word-break: break-word"> ${ucFirst(
				relationship
			)}</td></tr>` +
			`<tr><td>${i18n.t('label.phone')}:</td><td style="word-break: break-word"> ${phone}</td></tr>` +
			`<tr><td>${i18n.t('label.email')}:</td><td style="word-break: break-word"> ${email}</td></tr></table>`,
		showConfirmButton: showEditButton,
		confirmButtonText: i18n.t('buttons.edit_user_info'),
		confirmButtonColor: '#3085d6',
		showCloseButton: true,
		customClass: 'otp_message_success'
	}).then(result => {
		if (result.value) {
			callback();
		}
	});
}
export function viewGuarantorDetails(userDetails, loanObject) {
	const email = userDetails.email ? userDetails.email : '';
	const phone = userDetails.phone ? userDetails.phone : '';
	let status;
	if (loanObject.guarantor_action) {
		status = loanObject.guarantor_action === 'ACCEPTED' ? 'Approved' : 'Rejected';
	} else {
		status = 'Pending';
	}
	Swal.fire({
		html:
			`<table class="popup"><tr><td>${i18n.t('label.full_name')}:</td><td>${userDetails.name}</td></tr>` +
			`<tr><td>${i18n.t('label.phone')}:</td><td> ${phone}</td></tr>` +
			`<tr><td>${i18n.t('label.email')}:</td><td> ${email}</td></tr>` +
			`<tr><td>${i18n.t('label.status')}:</td><td> ${status}</td></tr>
               </table>`,
		showCloseButton: true,
		customClass: 'otp_message_success'
	});
}

export function viewUserDetailsGuarantor(userDetails) {
	const email = userDetails.email ? userDetails.email : 'None';
	const phone = userDetails.phone ? userDetails.phone : 'None';
	const name = userDetails.name ? userDetails.name : 'None';
	Swal.fire({
		html:
			`<table class="popup"><tr><td>${i18n.t('label.full_name')}:</td><td>${name}</td></tr>` +
			`<tr><td>${i18n.t('label.phone')}:</td><td> ${phone}</td></tr>` +
			`<tr><td>${i18n.t('label.email')}:</td><td> ${email}</td></tr></table>`,
		showCloseButton: true,
		customClass: 'otp_message_success'
	});
}

export function toastSuccessResendLoan(typeOfLoan, nameofAcceptor) {
	const acceptanceMessage = i18n.t('sweetalert.text_for_loan_resend_success', {
		loan_type: typeOfLoan,
		loan_acceptor: nameofAcceptor
	});
	Swal.fire({
		animation: false,
		title: i18n.t('sweetalert_title.congratulations'),
		text: acceptanceMessage,
		icon: 'success',
		confirmButtonText: i18n.t('buttons.ok'),
		customClass: 'otp_message_success'
		// customClass: {
		//   confirmButton: "circular-button",
		// },
	});
}

export function toastOnConfirmChanges(callback, data, back) {
	Swal.fire({
		text: i18n.t('sweetalert.confirm_changes'),
		icon: 'warning',
		showCancelButton: true,
		confirmButtonText: i18n.t('label.yes'),
		cancelButtonColor: '#d33',
		cancelButtonText: i18n.t('label.no'),
		customClass: 'otp_message_success'
	}).then(result => {
		if (result.value) {
			callback(data);
		} else {
			back();
		}
	});
}

export function toastWhenDocumentIsSubmitted(openScreen) {
	Swal.fire({
		title: i18n.t('sweetalert_title.thank_you'),
		text: i18n.t('sweetalert.text_when_document_submitted'),
		icon: 'warning',
		confirmButtonText: i18n.t('buttons.ok'),
		customClass: 'otp_message_success'
	}).then(() => {
		openScreen('LOAN_LIST');
	});
}

export function toastWhenDocumentIsRejected(reason) {
	Swal.fire({
		title: i18n.t('sweetalert_title.sorry'),
		text: i18n.t('sweetalert.text_when_document_rejected') + reason,
		icon: 'warning',
		confirmButtonText: i18n.t('buttons.ok'),
		customClass: 'otp_message_success'
	});
}

export function toastInvitationSent(loan) {
	const typeOfMessage =
		loan.loan_type === 'LEND'
			? i18n.t('sweetalert.invite_sent_successfully_lend')
			: i18n.t('sweetalert.invite_sent_successfully_borrow');
	Swal.fire({
		animation: false,
		title: i18n.t('sweetalert_title.sent'),
		text: typeOfMessage + ' ' + loan.name + '. ' + i18n.t('sweetalert.additional_invitation_message'),
		icon: 'success',
		confirmButtonText: i18n.t('buttons.ok'),
		customClass: 'otp_message_success'
	});
}

export function toastWaitForFurtherStep() {
	Swal.fire({
		title: i18n.t('sweetalert_title.thank_you'),
		text: i18n.t('sweetalert.cant_recognize_please_wait_for_further_step'),
		icon: 'warning',
		confirmButtonText: i18n.t('buttons.ok'),
		customClass: 'otp_message_success'
	});
}

export function toastKbaInitaitedPleaseRetuenAfterSomethime() {
	// NOSONAR
	Swal.fire({
		title: i18n.t('sweetalert_title.thank_you'),
		text: i18n.t('sweetalert.cant_recognize_please_wait_for_further_step'),
		icon: 'warning',
		confirmButtonText: i18n.t('buttons.ok'),
		customClass: 'otp_message_success'
	});
}

export function toastWhenViewSummaryRender() {
	Swal.fire({
		text: i18n.t('sweetalert.text_on_view_summary_render'),
		icon: 'warning',
		confirmButtonText: i18n.t('buttons.ok'),
		customClass: 'otp_message_success'
	});
}

export function toastUserCanceledLoan() {
	Swal.fire({
		title: i18n.t('sweetalert_title.sorry'),
		text: i18n.t('sweetalert.user_canceled_loan'),
		icon: 'warning',
		confirmButtonText: i18n.t('buttons.ok'),
		customClass: 'otp_message_success'
	});
}

export function popUpForItemDescribed(itemDescription) {
	Swal.fire({
		html: `<h4>${itemDescription}</h4>`,
		width: '40%',
		showConfirmButton: false,

		customClass: 'otp_message_success'
	});
}

export function toastWhenViewProfile(toggleViewProfile) {
	Swal.fire({
		title: i18n.t('sweetalert_title.do_you_want_to'),
		icon: 'warning',
		confirmButtonText: i18n.t('buttons.view_profile'),
		cancelButtonText: i18n.t('buttons.cancel'),
		showCloseButton: true,
		customClass: 'otp_message_success'
	}).then(result => {
		if (result.value) {
			toggleViewProfile();
		}
	});
}

export function toastWhenWindowClose(text, callback, data) {
	const interpolationObject = text.message;
	for (const l of text.label) {
		interpolationObject[l] = i18n.t(`label.${l}`);
	}
	Swal.fire({
		title: i18n.t(text.title),
		html: i18n.t(text.messageKey, interpolationObject),
		icon: 'warning',
		confirmButtonText: i18n.t('buttons.continue'),
		showCloseButton: true,
		customClass: 'otp_message_success'
	}).then(result => {
		if (result.dismiss === 'close') {
			callback(data);
			Session.remove('LOAN_OBJECT');
		}
	});
}

export function toastForTenant(text) {
	Swal.fire({
		animation: false,
		title: 'Congratulations',
		text: text,
		icon: 'success',
		confirmButtonText: 'Ok',
		customClass: 'otp_message_success',
		showCloseButton: true
	}).then(result => {
		if (result.value) {
			window.location.href = '/admin/tenants';
		}
	});
}

export function toastOnTenantCreated(html, callback) {
	Swal.fire({
		animation: false,
		title: 'Congratulations',
		html: html,
		icon: 'success',
		confirmButtonText: 'Ok',
		showCloseButton: true,
		customClass: 'otp_message_success'
	}).then(() => {
		callback();
	});
}

export function toastOnDeleteRecordConfirm() {
	return new Promise(resolve => {
		Swal.fire({
			text: i18n.t('sweetalert.delete_record_confirm'),
			icon: 'warning',
			showCancelButton: true,
			confirmButtonText: i18n.t('label.yes'),
			cancelButtonColor: '#d33',
			cancelButtonText: i18n.t('label.no'),
			customClass: 'otp_message_success'
		}).then(result => {
			if (result) {
				resolve(result);
			}
		});
	});
}

export function toastIdSuccess(message) {
	Swal.fire({
		animation: false,
		title: i18n.t('sweetalert_title.congratulations'),
		text: message,
		icon: 'success',
		customClass: 'otp_message_success',
		confirmButtonText: i18n.t('buttons.ok')
	});
}
